import React, { useCallback, useEffect, useState } from 'react';
import ShSetup from '../SHSetup/ShSetup';
import HistoricalReport from './HistoricalReport/HistoricalReport';

interface IPortableWindowManager {}

function PortableWindowManager(props: IPortableWindowManager) {
    const [arrayWindows, setArrayWindows] = useState<any[]>([]);
    const [countWin, setCountWin] = useState<number>(5);

    const OpenPortableWin = (event: any) => {
        const tempArr = [...arrayWindows];

        const tempItem = tempArr.find((item) => item.name == event.detail.name);
        if (tempArr)
            tempArr.forEach((item) => {
                item.active = false;
            });

        if (!tempItem) {
            const newWin = {
                name: event.detail.name,
                active: true
            };

            tempArr.push(newWin);

            setArrayWindows(tempArr);
        } else {
            tempItem.active = true;
            setArrayWindows(tempArr);
        }
    };

    //Сменить активный таб
    function SetActiveTab(indexActive: number) {
        const newArray = arrayWindows.map((item, index) => ({
            ...item,
            active: index === indexActive ? true : false
        }));

        setArrayWindows(newArray);
    }

    useEffect(() => {
        document.addEventListener('centum_open_faceplate', OpenPortableWin);

        return () => {
            document.removeEventListener('centum_open_faceplate', OpenPortableWin);
        };
    }, [OpenPortableWin]);

    const CloseItem = (index: number) => {
        let TempArray = [...arrayWindows];
        TempArray.splice(index, 1);
        setArrayWindows(TempArray);
    };

    function createPortableWin(item: any, index: number) {
        switch (item.name) {
            case '.SH':
                return (
                    <ShSetup
                        index={index}
                        item={item}
                        SelectActiveTab={SetActiveTab}
                        CloseSettings={() => CloseItem(index)}
                    />
                );
            case '.HR':
                return (
                    <HistoricalReport
                        index={index}
                        item={item}
                        SelectActiveTab={SetActiveTab}
                        CloseSettings={() => CloseItem(index)}
                    />
                );
            default:
                return <></>;
        }
    }

    return (
        <>
            {arrayWindows.map((item, index) => {
                return <div key={`faceplate-${item.name}`}>{createPortableWin(item, index)}</div>;
            })}
        </>
    );
}

export default PortableWindowManager;
